import { type ValueOf } from "./utility-types/value-of.types";

import type { PgsPaymentMethod } from "./PgsPaymentMethod";

export const customPaymentMethods = {
  payOnDelivery: "cashondelivery",
  zeroValueOrder: "free",
} as const;

type CustomPaymentMethodValues = ValueOf<typeof customPaymentMethods>;
export type CustomPaymentMethod = {
  code: CustomPaymentMethodValues;
  title: string;
  icon?: string;
  definition?: string;
  tokenizable?: boolean;
  enabled: boolean;
};

export type PaymentMethod = (PgsPaymentMethod & { definition?: never }) | CustomPaymentMethod;
